type IconProps = {
	width?: number;
	height?: number;
	maskColor?: string;
	color?: string;
}

export const RCPalletsIcon = (props: IconProps) => {
	const {
		width = 13,
		height = 14,
		color = 'currentColor'
	} = props;
	return (
		<svg role={'img'} width={width} height={height} viewBox='0 0 13 14' fill='none' xmlns='http://www.w3.org/2000/svg'>
			<path d='M5.07495 6.625H0.574951V10.375H5.07495V6.625Z' stroke={color} strokeMiterlimit='10'/>
			<path d='M8.74995 1.44995H3.57495V5.19995H8.74995V1.44995Z' stroke={color} strokeMiterlimit='10'/>
			<path d='M11.825 6.625H7.32495V10.375H11.825V6.625Z' stroke={color} strokeMiterlimit='10'/>
			<path d='M0.199951 12.625H2.44995' stroke={color} strokeMiterlimit='10'/>
			<path d='M9.94995 12.7H12.2' stroke={color} strokeMiterlimit='10'/>
			<path d='M6.94995 11.575H12.2' stroke={color} strokeMiterlimit='10'/>
			<path d='M0.199951 11.575H5.44995' stroke={color} strokeMiterlimit='10'/>
			<path d='M4.7749 12.625H6.8749' stroke={color} strokeMiterlimit='10'/>
		</svg>
	);
};
